export default __webpack_public_path__ + "static/media/i20.6806d78a.svg";